import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import Icona from 'components/3catinfo/ui/Icona/Icona';
import __isEmpty from 'lodash/isEmpty';
import React, { createElement, useEffect, useRef } from 'react';
import { components } from '../components';
import styles from './dropdown.module.scss';

const OptionDropdown = (props) => {
    const { options, id, seccio, openDropdown, setDropdownOpened, setIsSideMenuOpen } = props;

    const _buildOpcio = (element, i) => {
        const stylesLink = clsx(styles.itemLink, element.slug === seccio && styles.active);

        return (
            <li key={`dropdown-${id}-${element.id}-opcio-${i}`}>
                <Enllac
                    onClick={() => {
                        setDropdownOpened(null);
                        setIsSideMenuOpen('closing');
                        setTimeout(() => {
                            setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                        }, 500);
                    }}
                    className={stylesLink}
                    type={element.type}
                    id={element.id}
                    slug={element.slug}
                    dataTestId={`dropdown-link-${element.slug}`}
                >
                    <span>
                        {!__isEmpty(element.icona) && <Icona icona={element.icona} alt={element.icona_alt} ariaHidden={true} />}
                        {element.text}
                    </span>
                </Enllac>
            </li>
        );
    };

    const _iterateArrayOptions = () => {
        return options.map((element, i) => _buildOpcio(element, i));
    };

    const _iterateObjectOptions = () => {
        return Object.entries(options).map(([key, optionsObject]) => {
            if (key === 'informatius' || key === 'podcasts') {
                return null; // No renderitzar informatius, ni podcasts aquí
            }

            const stylesOptions = clsx({
                [styles[key]]: !!key
            });
            const stylesColumna = clsx({
                [styles.columna]: true
            });

            if (typeof optionsObject === 'object' && !Array.isArray(optionsObject) && optionsObject.component) {
                return (
                    <div className={`${stylesColumna} directes`} key={`dropdown-component-${id}-${key}`}>
                        {createElement(components[optionsObject.component], { openDropdown })}
                    </div>
                );
            }
            const stylesTipus = clsx({
                [styles[optionsObject[0].tipus]]: true
            });

            return (
                <div className={`${stylesColumna} ${stylesTipus} ${optionsObject[0].tipus}`} key={`dropdown-object-${id}-${key}`}>
                    <div className={styles.titolColumna} role='heading' aria-level='2'>
                        {optionsObject[0].titol}
                    </div>
                    <ul className={stylesOptions}>
                        <OptionDropdown
                            {...props}
                            options={optionsObject}
                            setDropdownOpened={setDropdownOpened}
                            setIsSideMenuOpen={setIsSideMenuOpen}
                        />
                    </ul>
                </div>
            );
        });
    };

    if (!__isEmpty(options)) {
        if (Array.isArray(options)) {
            return _iterateArrayOptions();
        } else {
            return _iterateObjectOptions();
        }
    }

    return <></>;
};

const Dropdown = ({
    item,
    role,
    dropdownOpened,
    setDropdownOpened,
    seccio,
    isMobile,
    isMenuSticky,
    setIsSideMenuOpen,
    isSideMenuOpen
}) => {
    const { id, opcions, text, icona } = item;
    const isOpen = dropdownOpened === id; // Verifica si aquest dorpdown està obert
    const buttonDropDown = useRef();
    const dropDownMenuRef = useRef();

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            // Tanca el dropdown amb la tecla Esc
            if (buttonDropDown.current) {
                buttonDropDown.current.focus();
            }
            setDropdownOpened(null);
        }
        if (e.key === 'Tab') {
            // Controla que el focus no surti del dropdown amb el Tab
            handleFocus(e);
        }
    };

    const handleFocus = (event) => {
        if (isOpen) {
            const focusableElem = Array.from(
                dropDownMenuRef.current.querySelectorAll("a, button, [tabindex]:not([tabindex='-1'])")
            );

            const firstFocusableElem = focusableElem[0];
            const lastFocusableElem = focusableElem[focusableElem.length - 1];
            const isTabPressed = event.key === 'Tab';

            if (!isTabPressed) {
                return;
            }

            if (event.shiftKey) {
                if (document.activeElement === firstFocusableElem) {
                    lastFocusableElem.focus();
                    event.preventDefault();
                }
            } else if (document.activeElement === lastFocusableElem) {
                firstFocusableElem.focus();
                event.preventDefault();
            }
        }
    };

    useEffect(() => {
        // Función para manegar el click fora
        const handleClickOutside = (event) => {
            if (!event.target.closest('[data-dropdown="true"]')) {
                setDropdownOpened(null); // Tanca el dropdown si es fa click fora d'ell
                if (isMenuSticky) {
                    // Tanca el sidebarMenu al mateix temps que es tanca el dropdown
                    setIsSideMenuOpen('closing');
                    setTimeout(() => {
                        setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                    }, 500);
                }
            }
        };

        // Función per manegar l'scroll
        const handleScroll = () => {
            if (isOpen) {
                setDropdownOpened(null); // Tanca el dropdown si es fa click fora d'ell
                if (isMenuSticky) {
                    setIsSideMenuOpen('closing');
                    setTimeout(() => {
                        setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                    }, 500);
                } else {
                    setIsSideMenuOpen('closed');
                }
            }
        };

        if (isOpen) {
            window.addEventListener('click', handleClickOutside);
            window.addEventListener('scroll', handleScroll); // Agrega listener de scroll
            window.addEventListener('keydown', handleKeyDown);
        } else {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('scroll', handleScroll); // Remou listener de scroll
            // window.removeEventListener('keyup', _tancaMenu);
        }

        return () => {
            window.removeEventListener('click', handleClickOutside); // Cleanup al desmontar
            window.removeEventListener('scroll', handleScroll); // Cleanup al desmontar
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const AccesTN = ({ informatius }) => {
        return (
            <div className={styles.accesTNs}>
                <div className={styles.titolColumna} role='heading'>
                    Programes informatius
                </div>
                <ul>
                    {informatius &&
                        Array.isArray(informatius) &&
                        informatius.length > 0 &&
                        informatius.map((item, index) => (
                            <li key={item.id || item.slug || index}>
                                <Enllac className={styles.botoInformatius} href={item.url} rel='noopener noreferrer'>
                                    <span className={styles.text}>{item.text}</span>
                                    <Icona icona='ic_linkexterior' className={styles.iconaLink} />
                                </Enllac>
                            </li>
                        ))}
                </ul>
            </div>
        );
    };

    const MenuPodcast = ({ podcasts }) => {
        
        return (
            <div className={`${styles.columna} ${styles.podcasts}`}>
                <div className={styles.titolColumna} role='heading'>
                    Pòdcasts
                </div>
                <ul>
                    {podcasts &&
                        Array.isArray(podcasts) &&
                        podcasts.length > 0 &&
                        podcasts.map((item, index) => (
                            <li key={item.id || item.slug || index}>
                                <Enllac className={styles.botoInformatius} type={item.type} id={item.id} slug={item.slug} rel='noopener noreferrer'>
                                    <span className={styles.text}>{item.text}</span>
                                    <Icona icona='ic_linkexterior' className={styles.iconaLink} />
                                </Enllac>
                            </li>
                        ))}
                </ul>
            </div>
        );
    };
    const stylesIcon = clsx({
        [styles.iconaDropdown]: true,
        [styles.open]: isOpen
    });

    const stylesContentDropdown = clsx({
        [styles.dropdown]: true,
        [styles.isNotSticky]: !isMenuSticky,
        [styles.open]: isOpen
    });

    const stylesWrapperDropdown = clsx({
        [styles.isSticky]: isMenuSticky,
        [styles.sideOpen]: isSideMenuOpen === 'opened'
    });

    const stylesBotoDropdown = clsx({
        ['botoDropdown']: true,
        [styles.botoDropdown]: true,
        [styles.open]: isOpen
    });

    const stylesbgDropdown = clsx({
        [styles.bgDropdown]: true,
        [styles.bgDirectes]: opcions.directes
    });

    return (
        <div ref={dropDownMenuRef}>
            <div className={stylesWrapperDropdown} style={{ width: '100%' }}>
                <button
                    ref={buttonDropDown}
                    data-testid={`drop-down-${id}`}
                    className={stylesBotoDropdown}
                    aria-expanded={isOpen}
                    aria-controls={id}
                    role={role}
                    onClick={(e) => {
                        e.stopPropagation(); // Evita que el clic es propagui al document
                        setDropdownOpened(isOpen ? null : id);
                    }}
                    tabIndex={isSideMenuOpen === 'opened' || !isMenuSticky ? '0' : '-1'}
                >
                    <span>
                        <span dangerouslySetInnerHTML={{ __html: text }} />
                        {!__isEmpty(icona) && (
                            <Icona icona={icona} className={styles.iconaItem} inline={true} mida={20} ariaHidden={true} />
                        )}
                    </span>
                    {isMobile || isMenuSticky ? (
                        <Icona className={stylesIcon} icona='fletxa_simple_dreta' alt='Desplegar menú' mida='16' inline={true} />
                    ) : (
                        <Icona className={stylesIcon} icona='fletxa_simple_avall' alt='Desplegar menú' mida='16' inline={true} />
                    )}
                </button>
                {isMenuSticky && (
                    <div className={stylesContentDropdown}>
                        <div className={stylesbgDropdown} data-dropdown='true'>
                            <div className={styles.overflowDropdown}>
                                <div className={styles.flexDropdown}>
                                    <div className={styles.wrapperOptions}>
                                        <OptionDropdown
                                            id={id}
                                            options={opcions}
                                            seccio={seccio}
                                            openDropdown={isOpen}
                                            setDropdownOpened={setDropdownOpened}
                                            setIsSideMenuOpen={setIsSideMenuOpen}
                                        />
                                    </div>
                                    {id === 'temes' && <div className={styles.wrapperProgrames}>
                                        <AccesTN informatius={opcions?.informatius} />
                                        <MenuPodcast podcasts={opcions?.podcasts} /></div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {!isMenuSticky && (
                <div className={stylesContentDropdown} id={id} style={{ position: 'absolute' }}>
                    <div className={stylesbgDropdown} data-dropdown='true'>
                        <div className={styles.overflowDropdown}>
                            <div className={styles.flexDropdown}>
                                <div className={styles.wrapperOptions}>
                                    <OptionDropdown
                                        id={id}
                                        options={opcions}
                                        seccio={seccio}
                                        openDropdown={isOpen}
                                        setDropdownOpened={setDropdownOpened}
                                        setIsSideMenuOpen={setIsSideMenuOpen}
                                    />
                                </div>
                                
                                {id === 'temes' && <div className={styles.wrapperProgrames}>
                                        <AccesTN informatius={opcions?.informatius} />
                                        <MenuPodcast podcasts={opcions?.podcasts} />
                                        </div>}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

Dropdown.displayName = 'Dropdown';
export default Dropdown;
